'use strict';

import $ from 'jquery';
import jQuery from 'jquery';

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

export default function AjaxPagination() {

	(function($) {

		// The number of the next page to load (/page/x/).
		let pageNum = parseInt(ajaxpagination.startPage) + 1;

		// The maximum number of pages the current query can return.
		let max = parseInt(ajaxpagination.maxPages);

		// The link of the next page of posts.
		let nextLink = ajaxpagination.nextLink;

		// Button selector
		const trigger = '.js-pagination-trigger';

		/**
		 * Replace the traditional navigation with our own,
		 * but only if there is at least one page of new posts to load.
		 */
		if(pageNum <= max) {
			// Insert the "Load More Posts" link.
			$('.stories')
				.append('<div class="l-col3 stories-placeholder-'+pageNum+'"></div>')
				.append('<a class="js-pagination-trigger pagination-button link link--red" href="#">Load More Posts</a>');

			// Remove the traditional navigation.
			$('.js-pagination').remove();
		}

		/**
		 * Load new posts when the link is clicked.
		 */
		$(trigger).click(function() {

			// Are there more posts to load?
			if(pageNum <= max) {

				// Show that we're working.
				$(this).text('Loading posts...');

				$('.stories-placeholder-'+ pageNum).load(nextLink + ' .l-col3-col',
					function() {
						// Update page number and nextLink.
						pageNum++;
						nextLink = nextLink.replace(/\/page\/[0-9]?/, '/page/'+ pageNum);

						// Add a new placeholder, for when user clicks again.
						$(trigger)
							.before('<div class="l-col3 stories-placeholder-'+pageNum+'"></div>');

						// Update the button message.
						if(pageNum <= max) {
							$(trigger).text('Load More Posts');
						} else {
							$(trigger).text('No more posts to load.');
						}
					}
				);

			} else {
				$(trigger).append('.');
			}	

			return false;
		});

	})(jQuery);

};